import { defineStore } from 'pinia'

export const useDarkModeStore = defineStore('darkMode', {
  state: () => ({
    isDark: false
  }),
  
  actions: {
    toggle() {
      this.isDark = !this.isDark
      this.updateDOM()
      localStorage.setItem('darkMode', this.isDark)
    },
    
    initialize() {
      // Check localStorage first, then system preference
      const stored = localStorage.getItem('darkMode')
      if (stored !== null) {
        this.isDark = stored === 'true'
      } else {
        this.isDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      }
      this.updateDOM()
      
      // Listen for system theme changes
      window.matchMedia('(prefers-color-scheme: dark)')
        .addEventListener('change', e => {
          if (localStorage.getItem('darkMode') === null) {
            this.isDark = e.matches
            this.updateDOM()
          }
        })
    },
    
    updateDOM() {
      document.documentElement.classList.toggle('dark', this.isDark)
    }
  }
})
